import React from 'react/addons';
import cx from 'classnames';
import SimpleChoice from 'ofs/components/simple-choice/SimpleChoice';


const MobileBreadbar = React.createClass({
  propTypes: {
    currentPage: React.PropTypes.string.isRequired,
    links: React.PropTypes.object.isRequired,
  },

  handleChange(event) {
    const {links} = this.props;
    const {value} = event.target;
    window.location.assign(links[value].url);
  }, 

  render() {
    const {links, currentPage} = this.props;
    let options = Object.keys(links).map((slug) => {
      return <div value={slug} key={slug}>{links[slug].title}</div>
    });

    return(
      <div>
        <label className="ofs-Form__Label">Navigate to:</label>
        <SimpleChoice className="ofs-SimpleChoice" defaultValue={currentPage} onChange={this.handleChange}>
          {options}
        </SimpleChoice>
      </div>
    );
  },
});

export default MobileBreadbar;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/_MobileBreadbar.jsx
 **/